import { render, staticRenderFns } from "./OpenDeposits.vue?vue&type=template&id=2b08abf6"
import script from "./OpenDeposits.vue?vue&type=script&lang=js"
export * from "./OpenDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports